import './PredictionTextField.css';
import { useState, forwardRef, useEffect } from 'react';   

export default forwardRef(function PredictionTextField({ lookupFn, displayFn, className, placeholder, value, onChange }, ref) {
    const [displayValue, setDisplayValue] = useState('');
    const [prediction, setPrediction] = useState();

    function convertDisplayValue(value) {
        if (displayFn) {
            return displayFn(value) || '';
        }
        return value || '';
    }

    // Update display when ref value or controlled value changes
    useEffect(() => {
        if (ref?.current) {
            setDisplayValue(convertDisplayValue(ref.current.value));
        } else if (value !== undefined) {
            setDisplayValue(convertDisplayValue(value));
        }
    }, [ref, value, displayFn]);

    function handleChangeValue(inputValue) {
        setDisplayValue(inputValue);
        const result = lookupFn(inputValue);
        if (result) {
            setPrediction({
                display: result.displayValue,
                value: result.value
            });
        } else {
            setPrediction(null);
        }
    }

    function applyPrediction() {
        if (prediction) {
            setDisplayValue(prediction.display);
            if (ref?.current) {
                ref.current.value = prediction.value;
            } else if (onChange) {
                onChange(prediction.value);
            }
            setPrediction(null);
        }
    }

    return (
        <div className="prediction-field-container">
            <input 
                type="text" 
                className={`prediction-field ${className || ''}`}
                placeholder={placeholder || ''}
                value={displayValue}
                onChange={(e) => handleChangeValue(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Tab" && prediction) {
                        e.preventDefault();
                        applyPrediction();
                    }
                }}
                onBlur={applyPrediction}
            />
            <input 
                type="hidden"
                ref={ref}
            />
            {prediction &&
                <input 
                    className={`prediction-overlay ${className || ''}`} 
                    type="text" 
                    value={prediction.display} 
                    readOnly
                    tabIndex="-1"
                />
            }
        </div>
    );
});